import React, { FC } from "react";
import kypImg from "assets/icons/kyp_pageImg.svg";
import kypHImg from "assets/icons/kypHImg.svg";
import kypCImg from "assets/icons/kypCImg.svg";

interface ResultHeadingProps {
  resultData: any;
}

const ResultHeading: FC<ResultHeadingProps> = ({ resultData }) => {
  return (
    <div className="hidden md:flex gap-4 sm:gap-10 justify-center items-center my-8 w-full px-5">
      <img src={resultData?.ResultTitle === "Healthy" ? kypHImg : resultData?.ResultTitle === "CRITICAL" ? kypCImg : kypImg} alt="heading Img" className="w-32 lg:w-52 object-contain" />
      <div className="text-start sm:text-left">
        <p className="font-extrabold text-lg md:text-[22px]">{resultData.PolicyHolderName}</p>
        <p className="font-bold text-sm md:text-lg">{resultData.InsuranceCompanyName}</p>
        <p className={`text-[12px] md:text-base font-medium `}>{resultData.PolicyName}</p>
      </div>
    </div>
  );
};

export default ResultHeading;
